import React, { Component } from 'react';
import _ from 'lodash';

class MixedQuestion extends Component {
	constructor(props) {
		super(props);

		this.state = {
			value: []
		};
		this.handleCheck = this.handleCheck.bind(this);
		this.handleChange = this.handleChange.bind(this);
	}
	componentDidMount() {
		_.map(this.props.fieldcollection.answers, (answer, i) => {
			const { value, config: { replica } } = answer;
			const name = `assignedValueInput${i}`;
			this.setState({
				[name]: value
			});
			if (replica) {
				const toogleName = `toogleReplicaInput${i}`;
				const inputName = value;
				this.setState({
					[inputName]: '',
					[toogleName]: false
				});
			} else if (!replica) {
				const toogleName = `toogleSingleInput${i}`;
				this.setState({
					[toogleName]: false
				});
			}
		});
		const requiredReplica = _.map(
			this.props.fieldcollection.answers,
			answer => {
				const { replica } = answer.config;
				if (replica) {
					return parseInt(answer.value, 10);
				}
			}
		);
		this.setState({
			valuesWithReplica: _.compact(requiredReplica)
		});
	}
	handleValidation(value, string = null) {
		const requiredReplica = _.includes(
			this.state.valuesWithReplica,
			parseInt(value, 10)
		);
		const emptyValue = _.isEqual(value, ['']) || _.isEmpty(value);
		const emptyString = _.isEmpty(string);
		if (requiredReplica && !emptyString) {
			return true;
		} else if (requiredReplica && emptyString) {
			return false;
		} else if (emptyValue) {
			return false;
		}
		return true;
	}
	handleParentStateCallback(value) {
		const { id, inputName } = this.props.fieldcollection;
		const validation = this.handleValidation(value);
		const obj = {
			id,
			inputName,
			validation,
			value
		};
		this.props.parentStateCallback(obj);
	}

	handleCheck(e) {
		const { checked, value, name } = e.target;
		const { id } = this.props.fieldcollection;
		this.setState({
			[name]: checked
		});
		if (checked) {
			this.setState(prevState => {
				const addInputValue = [...prevState.value, value];
				this.handleParentStateCallback(addInputValue);
				return {
					value: addInputValue					
				}
			});
		} else if (!checked) {
			this.setState(prevState => {
				const removeInputValue = _.without(prevState.value, value);
				this.handleParentStateCallback(removeInputValue);
				this.props.parentStateCallbackReplicaRemove(id, value);
				return {
					value: removeInputValue,
					[value]: ''					
				}
			});
		}
	}
	handleChange(e) {
		const { value, name } = e.target;
		const { id } = this.props.fieldcollection;
		this.setState({
			[name]: value
		});
		const validation = this.handleValidation(name, value);
		this.props.parentStateCallbackReplicaAdd(id, name, value, validation);
	}
	renderInputTxt(answer, i) {
		const { value, config } = answer;
		return (
			<input
				type="text"
				name={answer.value}
				value={this.state[answer.value]}
				onChange={this.handleChange}
				className={_.includes(this.state.value, value) ? "form-control mb-3" : "d-none"}
				placeholder={config.replicaLabel}
				required={_.includes(this.state.value, value)}
				disabled={_.includes(this.state.value, value) ? false : true}
			/>
		);
	}
	renderInputNum(answer, i) {
		const { config } = answer;
		return (
			<React.Fragment>
				<input
					type="number"
					name={answer.value}
					value={this.state[answer.value]}
					onChange={this.handleChange}
					min={config.numMin}
					max={config.numMax}
					step="1"
					className={_.includes(this.state.value, answer.value) ? "form-control" : "d-none"}
					placeholder={config.replicaLabel}
					required={_.includes(this.state.value, answer.value)}
					disabled={_.includes(this.state.value, answer.value) ? false : true}
				/>
				<small className={_.includes(this.state.value, answer.value) ? "form-text text-muted mb-3" : "d-none"}>
					Digite un número entre {config.numMin} y {config.numMax}.
				</small>
			</React.Fragment>
		);
	}
	builder({ answers, question, id }) {
		return _.map(answers, (answer, i) => {
			const inputId = `${id}_${answer.value}`;

			if (answer.config.replica) {
				return (
					<div className="form-check" key={i}>
						<input
							type="checkbox"
							name={`toogleReplicaInput${i}`}
							checked={this.state[`toogleReplicaInput${i}`]}
							value={this.state[`assignedValueInput${i}`]}
							id={inputId}
							onChange={this.handleCheck}
							className="form-check-input"
						/>

						<label htmlFor={inputId} className="form-check-label">
							{answer.label}
						</label>

						{answer.config.mostBeNum
							? this.renderInputNum(answer, i)
							: this.renderInputTxt(answer, i)}
					</div>
				);
			}
			return (
				<div className="form-check" key={i}>
					<input
						type="checkbox"
						name={`toogleSingleInput${i}`}
						checked={this.state[`toogleSingleInput${i}`]}
						value={this.state[`assignedValueInput${i}`]}
						onChange={this.handleCheck}
						id={inputId}
						className="form-check-input"
					/>
					<label htmlFor={inputId} className="form-check-label">
						{answer.label}
					</label>
				</div>
			);
		});
	}
	render() {
		const { question } = this.props.fieldcollection;
		return (
			<div className="border rounded px-4 py-3 mb-4">
				<h5>{question}</h5>
				{_.includes(this.props.errors, this.props.fieldcollection.id) && (
					<div className="alert alert-danger">Selecione un valor.</div>
				)}
				<div>{this.builder(this.props.fieldcollection)}</div>
				<br />
				<div className="d-none">valor: {this.state.value.sort().toString()}</div>
			</div>
		);
	}
}

export default MixedQuestion;



// WEBPACK FOOTER //
// ./src/components/Survey/consumer/FieldCollection/MixedQuestion.js